const paths = ["/base", "/plus"];

export const allowedPaths = [
  ...paths,
  "/resume",
  ...paths.map(p => `/resume${p}`),
  "/status",
  "/not-found",
];

export const defaultPath = paths[0];
